import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-left",
  "use": "icon-left-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-left\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 15H0.842105V13.2604H16V15ZM5.06105 2.22987L2.38147 4.99751L5.06105 7.76516L3.87032 8.99503L0 4.99751L3.87032 1L5.06105 2.22987ZM16 8.91153H8.42105V7.17197H16V8.91153ZM16 2.82306H8.42105V1.0835H16V2.82306Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol